import axios from "axios";
import { base_url } from "../../utils/baseUrl";



const getAdvisoryBoards = async () => {
  
  const response = await axios.get(`${base_url}advisoryBoard/getAllAdvisoryBoards`);
 
  return response.data;
  
};
const createAdvisoryBoard = async (values) => {
  const response = await axios.post( `${base_url}advisoryBoard/addAdvisoryBoard`,values);

  return response.data;
};

const updateAdvisoryBoard = async (values) => {
  const id = values.get("id") 
  const response = await axios.put(
    `${base_url}advisoryBoard/editAdvisoryBoard/${id}`,
    values

  );

  return response.data;
};

const getAdvisoryBoard = async (id) => {
  const response = await axios.get(`${base_url}advisoryBoard/getById/${id}`);

  return response.data;
};

const deleteAdvisoryBoard = async (id) => {
  const response = await axios.delete(`${base_url}advisoryBoard/deleteAdvisoryBoard/${id}`);

  return response.data;
};
const AdvisoryBoardService = {
  getAdvisoryBoards,
  createAdvisoryBoard,
  getAdvisoryBoard,
  updateAdvisoryBoard,
  deleteAdvisoryBoard,
};

export default AdvisoryBoardService;
